import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Modal from "react-bootstrap/Modal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'
import { connect } from "react-redux";
import { getMemberPaymentDetails_action, checkAvailableUsername_action, insertUpdatePayment_action, registrationPreview_action } from '../../../actions/staticAction/registration_action'
import { sendPaymentForm_action } from '../../../actions/paymentAction/paymentAction'
import { toastError, toastSuccess, DOC_BASE_URL, downloadReport, pgViewChargesActionId } from '../../../utils/constants'
import { countDownDate_action } from '../../../actions/staticAction/static_action';
import moment from 'moment/moment';
import { fill_action } from '../../../actions/fillCombo_action';
class Payment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isVerfied: null,
            MemberID: '',
            promoCode: '',
            promoCodeID: '',
            membershipFee: '',
            CGST: '',
            SGST: '',
            IGST: '',
            discount: '',
            toPay: '',
            disclaimer: false,
            rulesAndRegulations: false,
            isOpen: false,
            isOpen2: false,
            RandRpath: '',
            geturl: '',
            userName: '',
            userNameErr: '',
            pgViewChargesModal: false,
            pgViewChargesFillList: [],
            isPromoApplied: false,
            //cms
            cmsSectionData: [], cmsMenuData: [], cmsFooterData: []
        }
        this.getDetails = this.getDetails.bind(this);
        this.onOfflineSubmit = this.onOfflineSubmit.bind(this);
        this.checkAvailableUsername = this.checkAvailableUsername.bind(this);

    }

    async componentDidMount() {
        // const isTimeout = await this.getCountDownDate();
        // if (isTimeout) {
        //     this.props.navigate('/')
        // } else {
        window.scrollTo(0, 0)
        sessionStorage.setItem("currentPage", 'payment')
        this.getFillList(pgViewChargesActionId, "", "", "", "")
        this.getDetails()

    }
    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true });
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === pgViewChargesActionId) {
                            this.setState({ pgViewChargesFillList: data.data });
                            resolve(true);
                        }
                    } else {
                        this.setState({ isLoading: false });
                    }
                });
        });
    }

    getCountDownDate() {
        const { } = this.state
        this.setState({ isLoading: true })
        return this.props
            .countDownDate_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        const LaunchDate = data.data[0]['countDownDate']
                        const targetDate = moment.utc(LaunchDate);
                        // Current date in UTC
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        return totalSeconds > 0;
                    }
                    this.setState({ isLoading: false })
                }
                this.setState({ isLoading: false });
                if (data.error == 1) toastError(data.data.ErrorMsg);
                return false;
            });
    }

    getDetails(code, promoStatus) {
        const { promoCode, isPromoApplied } = this.state
        this.setState({ isLoading: true })
        console.log('ppp22')
        this.props
            .getMemberPaymentDetails_action(parseInt(sessionStorage.getItem("MemberID")), !promoStatus ? promoCode : '')
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        var paymentDetails = data.data[0][0]
                        var agreementDetails = data.data[1][0]
                        this.setState({
                            MemberID: agreementDetails.MeMberID,
                            membershipFee: paymentDetails.RegistrationFee,
                            CGST: paymentDetails.CGST,
                            SGST: paymentDetails.SGST,
                            IGST: paymentDetails.IGST,
                            discount: paymentDetails.Discount,
                            toPay: paymentDetails.Total,
                            RandRpath: agreementDetails.RulesPath,
                            promoCodeID: agreementDetails.PromocodeID,
                        })
                        if (code != undefined) {
                            setTimeout(() => {
                                if (!isPromoApplied) {
                                    if (paymentDetails.Discount != 0 && paymentDetails.Discount != null && paymentDetails.Discount != '' && code != undefined) {
                                        this.setState({ isPromoApplied: true }, () => {
                                            toastSuccess("PromoCode Applied Successfully")
                                        })
                                    }
                                } else {
                                    this.setState({ isPromoApplied: false, promoCode: '' })
                                }
                            }, 200);
                        } else {
                            this.setState({
                                disclaimer: agreementDetails.IsAgreeClaim,
                                rulesAndRegulations: agreementDetails.IsAgreeRules,
                            })
                        }
                    } else {
                        toastError('Invalid PromoCode');
                    }
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg);
                }
            })
    }

    handlePrevious() {
        this.props.navigate('/buisnessDetails')
        sessionStorage.setItem("currentPage", 'buisnessDetails')
    }

    onRRaccept() {
        this.setState({
            rulesAndRegulations: true,
            isOpen: false
        })
    }

    checkAvailableUsername(mode) {
        const { userName, } = this.state
        return new Promise((resolve) => {
            if (userName.length >= 6) {
                this.setState({
                    isLoading: true,
                })
                this.props
                    .checkAvailableUsername_action(userName)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({
                                userNameErr: '',
                                isVerfied: true,
                                isLoading: false
                            })
                            resolve(true)
                        } else {
                            mode != 1 && toastError(`${data.msg}`)
                            this.setState({
                                userNameErr: data.msg,
                                isVerfied: false,
                                isLoading: false
                            })
                            resolve(false)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        toastError("Something went wrong...")
                        this.setState({
                            isVerfied: false,
                            isLoading: false
                        })
                        resolve(false)
                    });
            } else {
                this.setState({
                    userNameErr: 'Username should contain minimum 6 characters',
                    isVerfied: false
                })
                resolve(false)
            }
        })
    }

    onPreviewClick() {
        const { MemberID, } = this.state
        this.setState({ isLoading: true })
        this.props
            .registrationPreview_action(MemberID)
            .then((data) => {
                if (data != null) {
                    var url = `${downloadReport}?SessionIdentifier=${data}`;

                    console.log('url just before navigate', url)
                    this.setState({
                        isOpen2: true,
                        geturl: url,
                    })
                    setTimeout(() => {
                        this.setState({
                            isLoading: false
                        })
                    }, 5000);
                } else {
                    this.setState({ isLoading: false })
                    toastError('There is some problem. Please try again later!', {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false })
            });
    }

    onOfflineSubmit() {
        const { userNameErr, promoCode, isPromoApplied, MemberID, promoCodeID, rulesAndRegulations, userName, toPay, disclaimer, } = this.state
        if (userName != '' && userName != null) {
            if (userNameErr == '' || userNameErr == null) {
                if (!disclaimer || !rulesAndRegulations) {
                    if (!disclaimer)
                        toastError("Please Agree to Disclaimer")
                    if (!rulesAndRegulations)
                        toastError("Please Agree to Rules and Regulations")
                } else {
                    this.checkAvailableUsername(1).then(res => {
                        if (res) {
                            this.setState({ isLoading: true })
                            this.props
                                .insertUpdatePayment_action(MemberID, disclaimer, rulesAndRegulations, promoCodeID, isPromoApplied ? promoCode : '', 0, userName, toPay)
                                .then((data) => {
                                    if (data.error != 1) {
                                        this.setState({ isLoading: false })
                                        var memberData = data.data[2][0]
                                        var MembershipNo = memberData.MembershipNo
                                        console.log('memberDate', memberData)
                                        sessionStorage.setItem("MembershipNo", MembershipNo)
                                        this.props.navigate('/thankyou')
                                        sessionStorage.setItem("currentPage", 'thankyou')
                                    } else {
                                        this.setState({ isLoading: false })
                                        toastError("Something went wrong...")
                                    }
                                }).catch(err => {
                                    this.setState({ isLoading: false })
                                    console.log(err)
                                    toastError("Something went wrong...")
                                })
                        }
                    })
                }
            }
            else {
                toastError("Please enter proper Username")
            }
        } else {
            this.setState({
                userNameErr: "Please enter Username"
            })
            toastError("Please enter Username")
        }
    }

    onOnlineSubmit() {
        const { userNameErr, promoCode, MemberID, promoCodeID, isPromoApplied, rulesAndRegulations, userName, toPay, disclaimer, } = this.state
        if (userName != '' && userName != null) {
            if (userNameErr == '' || userNameErr == null) {
                if (!disclaimer || !rulesAndRegulations) {
                    if (!disclaimer)
                        toastError("Please Agree to Disclaimer")
                    if (!rulesAndRegulations)
                        toastError("Please Agree to Rules and Regulations")
                } else {
                    this.checkAvailableUsername(1).then(res => {
                        if (res) {
                            this.setState({ isLoading: true })
                            this.props
                                .insertUpdatePayment_action(MemberID, disclaimer, rulesAndRegulations, promoCodeID, isPromoApplied ? promoCode : '', 1, userName)
                                .then((data) => {
                                    console.log(data)
                                    if (data.error != 1) {
                                        var PIList = [{
                                            'ProformaInvoiceID': data.data[2][0].ProformaInvoiceID
                                        }]
                                        console.log("payment response : ", data)
                                        var memberData = data.data[2][0]
                                        var MembershipNo = memberData.MembershipNo
                                        console.log('memberDate', memberData)
                                        sessionStorage.setItem("MembershipNo", MembershipNo)
                                        // this.props.navigate('/thankyou')
                                        // sessionStorage.setItem("currentPage", 'thankyou')
                                        this.props.sendPaymentForm_action(MemberID, toPay, parseInt(sessionStorage.getItem('countryId')) == 91 ? 'INR' : 'USD', PIList, 'registrationForm')
                                            .then((data) => {
                                                console.log(data)
                                                if (data.error != 1) {
                                                    if (data != null) {
                                                        this.setState({ paymentLink: data.data }, () => {
                                                            window.location.replace(data.data)

                                                        })
                                                    }
                                                }
                                                else {
                                                    this.setState({ isLoading: false })
                                                    toastError('There is some problem. Please try again later!')
                                                }
                                            })
                                            .catch((err) => {
                                                console.log(err)
                                            })

                                        //     this.setState({ isLoading: false })

                                    } else {
                                        this.setState({ isLoading: false })
                                        toastError("Something went wrong...")
                                    }
                                }).catch(err => {
                                    this.setState({ isLoading: false })
                                    console.log(err)
                                    toastError("Something went wrong...")
                                })
                        }
                    })
                }
            }
            else {
                toastError("Please enter proper Username")
            }
        } else {
            this.setState({
                userNameErr: "Please enter Username"
            })
            toastError("Please enter Username")
        }
    }

    render() {
        const { isLoading, isOpen2, isOpen, geturl, isPromoApplied, promoCode,
            membershipFee, rulesAndRegulations, userNameErr, toPay, disclaimer,
            discount, SGST, CGST, IGST, cmsMenuData, cmsFooterData, pgViewChargesModal } = this.state

        const totalTaxable = parseFloat(membershipFee) - parseFloat(discount)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                    // <></>
                ) : (
                    null
                )}
                {!isOpen && <Header headerNavs={cmsMenuData} />}
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">

                        <div class="row mt-15">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body custom_form_fields pt-3">

                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="md-stepper-horizontal orange">
                                                    <div class="md-step" id="first_div">
                                                        <div class="md-step-circle"><span>1</span></div>
                                                        <div class="md-step-title">Company Profile</div>
                                                        <div class="md-step-bar-left"></div>
                                                        <div class="md-step-bar-right"></div>
                                                    </div>
                                                    <div class="md-step" id="second_div">
                                                        <div class="md-step-circle"><span>2</span></div>
                                                        <div class="md-step-title">Business Details</div>
                                                        <div class="md-step-bar-left"></div>
                                                        <div class="md-step-bar-right"></div>
                                                    </div>
                                                    <div class="md-step active" id="third_div">
                                                        <div class="md-step-circle"><span>3</span></div>
                                                        <div class="md-step-title">Payment</div>
                                                        <div class="md-step-bar-left"></div>
                                                        <div class="md-step-bar-right"></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="custom_tabs" id="mytabs">
                                                    <div class="tab-content">
                                                        <div class="tab-pane active" id="Payment_tab" role="tabpanel" aria-labelledby="Payment_tab" tabindex="0">
                                                            <div class="payment_tab">

                                                                <div class="row">
                                                                    <div class="col-md-12">

                                                                        <div class="payment_tab_main_div">
                                                                            <div class="heading_tab">
                                                                                <h4>Registration Detail</h4>
                                                                            </div>
                                                                            <div class="promocode_div">
                                                                                <h6>Create Username<span className="red-star text-danger">*</span></h6>
                                                                                <div class="apply_txt" style={{ display: 'flex' }}>
                                                                                    <input type="text" value={this.state.userName} onBlur={(e) => e.target.value != '' && e.target.value != null && userNameErr == '' && this.checkAvailableUsername()} class="form-control promoCode_txtbox" placeholder="Enter Username here" onChange={(e) => this.setState({ userName: e.target.value, userNameErr: e.target.value.includes(' ') ? 'Username cannot contain spaces' : '', isVerfied: null })} />
                                                                                    {this.state.isVerfied != null ? userNameErr != '' ? <span style={{
                                                                                        color: 'red',
                                                                                        position: 'absolute',
                                                                                        right: '4%',
                                                                                        scale: '1.5',
                                                                                        top: '20%'
                                                                                    }}>
                                                                                        <i class="fa fa-regular fa-circle-xmark"></i>
                                                                                    </span> : <span style={{
                                                                                        color: 'green',
                                                                                        position: 'absolute',
                                                                                        right: '4%',
                                                                                        scale: '1.5',
                                                                                        top: '20%'
                                                                                    }}>
                                                                                        <i class="fa fa-regular fa-circle-check"></i>
                                                                                    </span> : ''}
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block  ml-2'>{userNameErr}</span>}
                                                                            </div>
                                                                            <div class="promocode_div">
                                                                                <h6>Promo Code</h6>
                                                                                <div class="apply_txt">
                                                                                    <input type="text" class="form-control promoCode_txtbox" placeholder="Enter promo code here" disabled={isPromoApplied} value={promoCode} onChange={(e) => this.setState({ promoCode: e.target.value })} />
                                                                                    <button onClick={() => this.getDetails(promoCode, isPromoApplied)}>
                                                                                        <a class="apply_btn">{isPromoApplied ? 'Remove' : 'Apply'}</a>
                                                                                    </button>
                                                                                </div>

                                                                            </div>
                                                                            <h6 class="order_summary_txt">Order Summury</h6>
                                                                            <div class="main_content_div">
                                                                                <div class="content_grid">
                                                                                    <p>Registration Fee</p>
                                                                                    <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {membershipFee}</p>
                                                                                </div>
                                                                                {discount != 0 && discount != null && discount != '' &&
                                                                                    <div class="content_grid">
                                                                                        <p>Discount</p>
                                                                                        <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {discount}</p>
                                                                                        <i class="fa fa-minus"></i>
                                                                                    </div>
                                                                                }
                                                                                {discount != 0 && discount != null && discount != '' &&
                                                                                    <div class="content_grid">
                                                                                        <p>Total Taxable</p>
                                                                                        <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {totalTaxable}</p>
                                                                                    </div>
                                                                                }
                                                                                <div class="content_grid">
                                                                                    <p>CGST</p>
                                                                                    <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {CGST}</p>
                                                                                </div>
                                                                                <div class="content_grid">
                                                                                    <p>SGST</p>
                                                                                    <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {SGST}</p>
                                                                                </div>
                                                                                <div class="content_grid">
                                                                                    <p>IGST</p>
                                                                                    <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {IGST}</p>
                                                                                </div>
                                                                                <div class="content_grid">
                                                                                    <p>Total</p>
                                                                                    <p>{parseInt(sessionStorage.getItem('countryId')) == 91 ? '₹' : '$'} {toPay}</p>
                                                                                </div>
                                                                            </div>

                                                                            <div class="row">
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group">
                                                                                        <div class="custom-control custom-checkbox mb-15" onClick={() => this.setState({
                                                                                            disclaimer: !disclaimer
                                                                                        })}>
                                                                                            <input type="checkbox" class="custom-control-input" checked={disclaimer} value={disclaimer} />
                                                                                            <label class="custom-control-label" for="Disclaimer">Disclaimer <br></br>
                                                                                                <span style={{ color: 'grey' }}>
                                                                                                    By Submitting registration form, I give my consent to India ITME Society to verify the provided information submitted by me online by telephonic call or by Email and also to send me promotional information via digital and offline channels not limited to email, SMS, WhatsApp, print newsletter.
                                                                                                </span>
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="form-group">
                                                                                        <div class="custom-control custom-checkbox"
                                                                                            onClick={() => this.setState({ isOpen: true })}
                                                                                        // onClick={() => this.setState({
                                                                                        //     rulesAndRegulations: !rulesAndRegulations
                                                                                        // })}
                                                                                        >
                                                                                            <input type="checkbox" disabled class="custom-control-input mt-1" checked={rulesAndRegulations} value={rulesAndRegulations} />
                                                                                            <label class="custom-control-label" for="Rules_and_regulations">Rules and regulations <span className='text-primary' style={{ textDecoration: 'underline' }} onClick={() => this.setState({ isOpen: true })}>Click here</span></label>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>



                                                            <div class="row mt-15">
                                                                <div class="col-md-2 text-left pre-btn">
                                                                    <button onClick={() => this.handlePrevious()} class="btn btn-primary previous_btn" >
                                                                        Previous
                                                                    </button>
                                                                    {/* <a href="javascript:void(0)" id="back_to_tab_2"></a> */}
                                                                </div>
                                                                <div class="col-md-10 three-btn">
                                                                    <button class="btn btn-primary next_btn ms-2" onClick={() => this.onPreviewClick()}>
                                                                        Preview
                                                                    </button>
                                                                    <button class="btn btn-primary next_btn ms-2" onClick={() => this.onOfflineSubmit()}>
                                                                        {toPay == 0 ? 'Submit' : 'Submit & pay later'}
                                                                        {/* & pay later */}
                                                                    </button>
                                                                    {sessionStorage.getItem('isPgButton') == 1 ? <>
                                                                        {toPay != 0 && <>
                                                                            <button class="btn btn-primary next_btn ms-2"
                                                                                onClick={() => this.setState({ pgViewChargesModal: true })}>
                                                                                Submit & pay
                                                                            </button>
                                                                        </>}
                                                                    </> : <></>}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal
                    show={pgViewChargesModal}
                    onHide={() => this.setState({ pgViewChargesModal: false })}
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title style={{ width: "100%" }}>
                            <h4
                                className="mb-0 pt-2 thank-top-mes"
                                style={{ color: "#318958", textAlign: "center" }}
                            >
                                <strong style={{ textAlign: "center" }}>
                                    Bank Charges
                                </strong>
                            </h4>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {sessionStorage.getItem("isPgButton") == 1 ? <>
                            <div className="mt-3 fs-5 fw-bold">
                                <span className="text-danger text-center d-block">
                                    Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step
                                </span>
                            </div>
                            <table className="table table-bordered table-striped mg-b-0">
                                <thead>
                                    <tr>
                                        <th>Payment Mode</th>
                                        <th>Bank Charges</th>
                                    </tr>
                                </thead>
                                <tbody id="myTable">
                                    {this.state.pgViewChargesFillList.length > 0 ? (
                                        this.state.pgViewChargesFillList.map((data, i) => (
                                            <tr key={i}>
                                                <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                <td>{data.Value}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <>
                                            <tr>
                                                <td colSpan={6}>No Records Found...</td>
                                            </tr>
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </> : <></>}
                    </Modal.Body>
                    <Modal.Footer>
                        <button class="btn btn-primary next_btn ms-2"
                            onClick={() => this.onOnlineSubmit()}>
                            I agree & Proceed to Pay
                        </button>
                        <button
                            type="button"
                            className="btn ad-fil-btn"
                            data-bs-dismiss="modal"
                            style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                            onClick={() => this.setState({ pgViewChargesModal: false })}
                        >
                            OK
                        </button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={isOpen}
                    onHide={() => this.setState({ isOpen: !isOpen })}
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title style={{ width: "100%" }}>
                            <h4
                                className="mb-0 pt-2 thank-top-mes"
                                style={{ color: "#318958", textAlign: "center" }}
                            >
                                <strong style={{ textAlign: "center" }}>Rules & Regulations</strong>
                            </h4>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            id="myIframe"
                            style={{ marginTop: "0px" }}
                            src={`${DOC_BASE_URL + this.state.RandRpath}#toolbar=0&navpanes=0`}
                            width="1000px"
                            height="535px"
                            title="Rules & Regulations"
                        />
                        <div className="row mt-3">
                            <div className="col-md-10">
                                <p>
                                    I have read the space booking Rules and Regulation & agree to abide by them.
                                </p>
                            </div>
                            <div className="col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    style={{ padding: "4px 15px", float: "right" }}
                                    onClick={() => this.onRRaccept()}
                                >
                                    Accept
                                </button>
                                <button
                                    type="button"
                                    className="btn ad-fil-btn"
                                    data-bs-dismiss="modal"
                                    style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                                    onClick={() => this.setState({ isOpen: !isOpen })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={isOpen2}
                    onHide={() => this.setState({ isOpen2: !isOpen2 })}
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title style={{ width: "100%" }}>
                            <h4
                                className="mb-0 pt-2 thank-top-mes"
                                style={{ color: "#318958", textAlign: "center" }}
                            >
                                <strong style={{ textAlign: "center" }}>Preview</strong>
                            </h4>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            id="myIframe"
                            style={{ marginTop: "0px" }}
                            src={geturl}
                            width="1000px"
                            height="535px"
                            title="Preview"
                        />
                        <div className="row mt-3">
                            <div className="col-md-1">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    style={{ padding: "4px 15px", float: "right" }}
                                    onClick={() => this.setState({ isOpen2: false })}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn ad-fil-btn"
                            data-bs-dismiss="modal"
                            style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                            onClick={() => this.setState({ isOpen2: !isOpen2 })}
                        >
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>


                {!isOpen && <Footer footerData={cmsFooterData} />}

            </>)
    }
}

export default withRouter(connect(null, { countDownDate_action, sendPaymentForm_action, getMemberPaymentDetails_action, insertUpdatePayment_action, checkAvailableUsername_action, registrationPreview_action, fill_action })(Payment));